export default "__VITE_ASSET__CX$GiTgO__"